// extracted by mini-css-extract-plugin
export var headerCell = "_4x-1";
export var loadingSpinnerContainer = "_4x-4";
export var rowWrapper = "_4x-3";
export var standaloneTable = "_4x-5";
export var table = "_4x-0";
export var white = "_4x-2";